var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataApiDefaultLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.96833mm",
    height: "19.36927mm",
    viewBox: "0 0 53.7685 54.90503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #181f28;\n      }\n\n      .b {\n        fill: #4b9fd8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.92084,28.60791a3.83354,3.83354,0,0,0-3.10895,1.59766H2.25A2.2498,2.2498,0,0,0,.65918,34.04639l16.397,16.397a3.94719,3.94719,0,1,0,3.18976-3.17358L7.68213,34.70557H46.81177a3.84355,3.84355,0,1,0,3.10907-6.09766Zm-29.07892,20.427a2.02246,2.02246,0,1,1-2.02246,2.02246A2.0225,2.0225,0,0,1,20.84192,49.03491ZM49.92084,34.478a2.02246,2.02246,0,1,1,2.02246-2.02246A2.02229,2.02229,0,0,1,49.92084,34.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.06494,19.814,36.72339,4.35181a3.80687,3.80687,0,0,0,.05084-.50415A3.88306,3.88306,0,1,0,33.63281,7.624L45.8667,19.19873h-38.91a3.84768,3.84768,0,1,0,0,4.5H51.51807A2.25032,2.25032,0,0,0,53.06494,19.814ZM32.92664,5.87012A2.02246,2.02246,0,1,1,34.949,3.84766,2.02247,2.02247,0,0,1,32.92664,5.87012ZM3.84766,23.47119a2.02246,2.02246,0,1,1,2.02246-2.02246A2.02246,2.02246,0,0,1,3.84766,23.47119Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataApiDefaultLarge);
export default __webpack_public_path__ + "static/media/data-api_default_large.5de29e3863319834ad4271da8fe2e196.svg";
export { ForwardRef as ReactComponent };